// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout';
var marketingRouter = {
  path: '/marketing',
  component: Layout,
  redirect: '/PlatformCoupon/list',
  name: 'Marketing',
  meta: {
    title: '营销',
    icon: 'clipboard'
  },
  children: [{
    path: 'sign',
    component: function component() {
      return import('@/views/marketing/sign');
    },
    name: 'Sign',
    meta: {
      title: '签到',
      icon: ''
    },
    children: [{
      path: 'config',
      component: function component() {
        return import('@/views/marketing/sign/config/index');
      },
      name: 'signConfig',
      hidden: true,
      meta: {
        title: '签到配置',
        icon: ''
      }
    }, {
      path: 'record',
      component: function component() {
        return import('@/views/marketing/sign/record/index');
      },
      name: 'signRecord',
      hidden: true,
      meta: {
        title: '签到记录',
        icon: ''
      }
    }]
  }, {
    path: 'integral',
    component: function component() {
      return import('@/views/marketing/integral/index');
    },
    name: 'Integral',
    meta: {
      title: '积分',
      icon: ''
    },
    children: [{
      path: 'integralconfig',
      component: function component() {
        return import('@/views/marketing/integral/config/index');
      },
      name: 'integralConfig',
      meta: {
        title: '积分配置',
        icon: ''
      }
    }, {
      path: 'integrallog',
      component: function component() {
        return import('@/views/marketing/integral/integralLog/index');
      },
      name: 'integralLog',
      meta: {
        title: '积分日志',
        icon: ''
      }
    }]
  }, {
    path: 'seckill',
    component: function component() {
      return import('@/views/marketing/seckill/index');
    },
    name: 'Seckill',
    meta: {
      title: '秒杀',
      icon: ''
    },
    children: [{
      path: 'config',
      component: function component() {
        return import('@/views/marketing/seckill/seckillConfig/index');
      },
      name: 'SeckillConfig',
      meta: {
        title: '秒杀配置',
        icon: ''
      }
    }, {
      path: 'list/:timeId?',
      component: function component() {
        return import('@/views/marketing/seckill/seckillList/index');
      },
      name: 'SeckillList',
      meta: {
        title: '秒杀商品',
        icon: ''
      }
    }, {
      path: 'seckillActivity',
      component: function component() {
        return import('@/views/marketing/seckill/seckillActivity/index');
      },
      name: 'SeckillActivity',
      meta: {
        title: '秒杀活动',
        icon: ''
      }
    }, {
      path: 'creatSeckill/:id?/:type?',
      component: function component() {
        return import('@/views/marketing/seckill/seckillActivity/creatSeckill');
      },
      name: 'CreatSeckill',
      meta: {
        title: '添加秒杀商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/seckill/seckillActivity"
      }
    }]
  }, {
    path: 'atmosphere',
    name: 'atmosphere',
    meta: {
      title: '活动氛围',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/atmosphere/index');
    },
    children: [{
      path: 'list',
      name: "atmosphereList",
      meta: {
        title: '氛围列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/list');
      }
    }, {
      path: 'add/:id?',
      name: "addAtmosphere",
      meta: {
        title: '添加活动氛围',
        noCache: true,
        activeMenu: "/marketing/atmosphere/list"
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/addAtmosphere');
      }
    }]
  }, {
    path: 'square',
    name: 'square',
    meta: {
      title: '会场',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/square/index');
    },
    children: [{
      path: 'squareControl',
      name: "squareControl",
      meta: {
        title: '会场管理',
        noCache: true,
        keepAlive: true
      },
      component: function component() {
        return import('@/views/marketing/square/squareControl');
      }
    }, {
      path: 'squareRecord',
      name: "squareRecord",
      meta: {
        title: '会场明细',
        noCache: true,
        keepAlive: true
      },
      component: function component() {
        return import('@/views/marketing/square/squareRecord');
      }
    }, {
      path: 'meetingContributionFlowList',
      name: "meetingContributionFlowList",
      meta: {
        title: '贡献值明细',
        noCache: true,
        keepAlive: true
      },
      component: function component() {
        return import('@/views/marketing/square/meetingContributionFlowList');
      }
    }]
  }, {
    path: 'directpushactivity',
    name: 'directpushactivity',
    meta: {
      title: '直推活动',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/directpushactivity/index');
    },
    children: [{
      path: 'list',
      name: "directpushactivityList",
      meta: {
        title: '活动管理',
        noCache: true,
        keepAlive: true
      },
      component: function component() {
        return import('@/views/marketing/directpushactivity/directpushactivityList/list');
      }
    }, {
      path: 'awards',
      name: "awards",
      meta: {
        title: '获奖记录',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/directpushactivity/awards');
      }
    }, {
      path: 'add/:id?',
      name: "addDirectpushactivityList",
      meta: {
        title: '添加直推活动',
        noCache: true,
        activeMenu: "/marketing/directpushactivity/list"
      },
      component: function component() {
        return import('@/views/marketing/directpushactivity/directpushactivityList/addAtmosphere');
      }
    }]
  }, {
    path: 'border',
    name: 'border',
    meta: {
      title: '活动边框',
      icon: ''
    },
    component: function component() {
      return import('@/views/marketing/border/index');
    },
    children: [{
      path: 'list',
      name: "borderList",
      meta: {
        title: '活动边框列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/list');
      }
    }, {
      path: 'add/:id?',
      name: "addBorder",
      meta: {
        title: '添加活动边框',
        noCache: true,
        activeMenu: "/marketing/border/list"
      },
      component: function component() {
        return import('@/views/marketing/atmosphere/atmosphereList/addAtmosphere');
      }
    }]
  },
  // 订单活动
  {
    path: 'orderPromotion',
    name: 'OrderPromotion',
    meta: {
      title: '订单权益活动',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/orderPromotion/index');
    }
  }, {
    path: 'broadcast',
    name: 'Broadcast',
    meta: {
      title: '直播',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/broadcast/index');
    },
    children: [{
      path: 'list',
      name: 'BroadcastList',
      meta: {
        title: '直播间',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/broadcast/list/index');
      }
    }, {
      path: 'product',
      name: 'BroadcastProduct',
      meta: {
        title: '直播商品列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/broadcast/product/index');
      }
    }, {
      path: 'room',
      name: 'BroadcastRoom',
      meta: {
        title: '直播间管理',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/broadcast/room/index');
      }
    }, {
      path: 'assistant',
      name: 'BroadcastAssistant',
      meta: {
        title: '直播助手',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/broadcast/assistant/index');
      }
    }, {
      path: 'creatRoom/:roomId?/:type?',
      component: function component() {
        return import('@/views/marketing/broadcast/room/creatRoom');
      },
      name: 'CreatRoom',
      meta: {
        title: '添加直播间',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/broadcast/room"
      }
    }, {
      path: 'creatPro/:liveId?',
      component: function component() {
        return import('@/views/marketing/broadcast/product/creatPro');
      },
      name: 'CreatPro',
      meta: {
        title: '添加直播商品',
        icon: '',
        noCache: true,
        activeMenu: "/marketing/broadcast/product"
      }
    }]
  }, {
    path: 'PlatformCoupon',
    name: 'PlatformCoupon',
    meta: {
      title: '平台优惠券',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/platformCoupon/index');
    },
    children: [{
      path: 'list',
      name: 'PlatformCouponlist',
      meta: {
        title: '优惠劵列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/platformCoupon/couponList/index');
      }
    }, {
      path: 'creatCoupon/:id?/:copy?',
      name: 'CreatCoupon',
      meta: {
        title: '添加优惠劵',
        noCache: true,
        activeMenu: "/marketing/PlatformCoupon/list"
      },
      component: function component() {
        return import('@/views/marketing/platformCoupon/couponList/creatCoupon');
      }
    }, {
      path: 'couponRecord',
      name: 'couponRecord',
      meta: {
        title: '领取记录',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/platformCoupon/couponList/record');
      }
    }, {
      path: 'newGift',
      name: 'newGift',
      meta: {
        title: '用户有礼',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/platformCoupon/couponList/newGift');
      }
    }]
  }, {
    path: 'videoChannel',
    name: 'VideoChannel',
    meta: {
      title: '视频号',
      noCache: true
    },
    component: function component() {
      return import('@/views/videoChannel');
    },
    children: [{
      path: 'list',
      component: function component() {
        return import('@/views/videoChannel/videoList/index');
      },
      name: 'VideoChannelList',
      meta: {
        title: '商品列表',
        icon: '',
        noCache: true
      }
    }, {
      path: 'draftList',
      component: function component() {
        return import('@/views/videoChannel/draftList/index');
      },
      name: 'draftList',
      meta: {
        title: '草稿列表',
        icon: '',
        noCache: true
      }
    }, {
      path: 'apply',
      component: function component() {
        return import('@/views/videoChannel/apply/index');
      },
      name: 'videoApply',
      meta: {
        title: '申请接入',
        icon: '',
        noCache: true
      }
    }, {
      path: 'weChatcategory',
      component: function component() {
        return import('@/views/videoChannel/weChatcategoryAndBrand/index');
      },
      name: 'videoWeChatcategory',
      meta: {
        title: '微信商品类目',
        icon: '',
        noCache: true
      }
    }]
  }, {
    path: 'community',
    name: 'Community',
    meta: {
      title: '种草社区',
      noCache: true
    },
    component: function component() {
      return import('@/views/community');
    },
    children: [{
      path: 'classification',
      name: 'communityClassification',
      component: function component() {
        return import('@/views/community/classification/index');
      },
      meta: {
        title: '社区分类',
        icon: 'clipboard'
      }
    }, {
      path: 'topics',
      name: 'communityTopics',
      component: function component() {
        return import('@/views/community/topics/index');
      },
      meta: {
        title: '社区话题',
        icon: 'clipboard'
      }
    }, {
      path: 'content',
      name: 'communityContent',
      component: function component() {
        return import('@/views/community/content/index');
      },
      meta: {
        title: '社区内容',
        icon: 'clipboard'
      }
    }, {
      path: 'comments',
      name: 'communityComments',
      component: function component() {
        return import('@/views/community/comments/index');
      },
      meta: {
        title: '社区评论',
        icon: 'clipboard'
      }
    }, {
      path: 'config',
      name: 'communityConfig',
      component: function component() {
        return import('@/views/community/config/index');
      },
      meta: {
        title: '社区配置',
        icon: 'clipboard'
      }
    }]
  }, {
    path: 'content',
    name: 'Content',
    meta: {
      title: '公告内容',
      noCache: true
    },
    component: function component() {
      return import('@/views/content');
    },
    children: [{
      path: 'articleManager',
      name: 'articleManager',
      component: function component() {
        return import('@/views/content/article/list');
      },
      meta: {
        title: '文章管理',
        icon: 'clipboard'
      }
    }, {
      path: 'systemmessages',
      name: 'systemmessages',
      component: function component() {
        return import('@/views/content/systemmessages/list');
      },
      meta: {
        title: '系统消息',
        icon: 'clipboard',
        keepAlive: true
      }
    }, {
      path: 'systemmessagesadd/:id?',
      name: 'systemmessagesadd',
      component: function component() {
        return import('@/views/content/systemmessages/edit');
      },
      meta: {
        title: '添加系统消息',
        noCache: true,
        activeMenu: "/content/articleManager"
      }
    }, {
      path: 'articleCreat/:id?',
      name: 'articleCreat',
      component: function component() {
        return import('@/views/content/article/edit');
      },
      meta: {
        title: '添加文章',
        noCache: true,
        activeMenu: "/content/articleManager"
      }
    }, {
      path: 'classifManager',
      name: 'classifManager',
      component: function component() {
        return import('@/views/content/articleclass/list');
      },
      meta: {
        title: '文章分类',
        icon: 'clipboard'
      }
    }]
  }, {
    path: 'lottery',
    name: 'lottery',
    meta: {
      title: '抽奖活动',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/lottery/index');
    },
    children: [{
      path: 'list',
      name: 'lotterylist',
      meta: {
        title: '抽奖列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/lottery/couponList/index');
      }
    }, {
      path: 'creatCoupon/:id?/:type?',
      name: 'lotteryCreatCoupon',
      meta: {
        title: '新增抽奖',
        noCache: true,
        keepAlive: true,
        activeMenu: "/marketing/lottery/list"
      },
      component: function component() {
        return import('@/views/marketing/lottery/couponList/creatCoupon');
      }
    }, {
      path: 'winning',
      name: 'lotterycouponRecord',
      meta: {
        title: '抽奖记录',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/lottery/winning/index');
      }
    }]
  }, {
    path: 'rankingList',
    name: 'rankingList',
    meta: {
      title: '排行榜',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/rankingList/index');
    },
    children: [{
      path: 'list',
      name: 'rankinglist',
      meta: {
        title: '排行榜列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/rankingList/couponList/index');
      }
    }, {
      path: 'creatCoupon/:id?/:type?',
      name: 'rankingCreatCoupon',
      meta: {
        title: '新增排行榜',
        noCache: true,
        keepAlive: true,
        activeMenu: "/marketing/rankingList/list"
      },
      component: function component() {
        return import('@/views/marketing/rankingList/couponList/creatCoupon');
      }
    }]
  }, {
    path: 'concert',
    name: 'concert',
    meta: {
      title: '演唱会',
      noCache: true
    },
    component: function component() {
      return import('@/views/marketing/concert/index');
    },
    children: [{
      path: 'record',
      name: 'concertRecord',
      meta: {
        title: '用户记录',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/concert/user/record');
      }
    }, {
      path: 'list',
      name: 'concertList',
      meta: {
        title: '活动列表',
        noCache: true
      },
      component: function component() {
        return import('@/views/marketing/concert/activity/list');
      }
    }]
  }]
};
export default marketingRouter;